
import globals from '../../utils/globals';
import { screenerApiClient } from '../../hooks/api';

export const client = async (yyy, channel) => {
  const platformApiClient = await screenerApiClient({
    baseUrl: globals.devPortalUrl,
    baseAuthUrl: globals.authApiUrl,
    yyy
  });

  return {
    channel,
    service: platformApiClient
  };

};

export const internalApiClient = async (yyy, channel) => {
  const apiClient = await screenerApiClient({
    baseUrl: globals.apiUrl,
    baseAuthUrl: globals.authApiUrl,
    yyy
  });

  return {
    channel,
    service: apiClient
  };

};
